<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                Delete This Response?
            </p>
            <button @click="closeModal" type="button" class="close-icon">
                <i class="mdi mdi-close"></i>
            </button>
        </header>
        <section class="modal-card-body padding-bottom82">

            <p>Deleting response will affect the number of data collected. This action cannot be undone.</p>
            
        </section>
        <footer class="modal-card-foot">
            <button
                    class="button is-primary btn-site-properties bg-white color-black"
                    @click="removeRecord"
            >
                Delete
            </button>

            <button
                    class="button is-primary is-rounded btn-site-properties"
                    @click="closeModal"
            >
                Cancel
            </button>
        </footer>
    </div>
</template>
<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {Action} from 'vuex-class';
    import { cloneDeep as _cloneDeep } from 'lodash';

    @Component({ components: {}})

    export default class DeleteRecordModal extends Vue {
        public removeRecord() {
            this.$emit('deleteRecord');
            this.$emit('close');
        }
        public closeModal() {
            this.$emit('close');
        }
    }
</script>
<style module>
    
</style>
